import dayjs from 'dayjs';

const dateWall = (ctx) => {
  const today = dayjs()
  // Check if the selected date is after first day of the week + 14 days
  // Or today is before thursday of the current week and selected date is after sunday of current week
  const dateWall =  dayjs(ctx.selectedDate).isAfter(today.day(1).add(13, 'd').endOf('day')) || 
    (today.day() < 4 && dayjs(ctx.selectedDate).isAfter(today.day(1).add(6, 'd').startOf('day')));
  return dateWall;
}

export default dateWall